import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/index.css";
import "./css/Colors.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthProvider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeProvider";
import "./i18n/config";
import { WidthProvider } from "./contexts/WidthProvider";
import { BoatInfoProvider } from "./contexts/BoatInfoProvider";
import { SocketProvider } from "./contexts/SocketProvider";
import { FrasarioProvider } from "./contexts/FrasarioProvider";
import { SettingsProvider } from "./contexts/SettingsProvider";
import { ConversationsProvider } from "./contexts/ConversationsProvider";
import { SpeechProvider } from "./contexts/SpeechProvider";
import { ShipsProvider } from "./contexts/ShipsProvider";
import { LocationProvider } from "./contexts/LocationProvider";
import { MapProvider } from "./contexts/MapProvider";
import { InfoProvider } from "./contexts/InfoProvider";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <WidthProvider>
          <InfoProvider>
            <AuthProvider>
              <SettingsProvider>
                <BoatInfoProvider>
                  <FrasarioProvider>
                    <SocketProvider>
                      <SpeechProvider>
                        <ConversationsProvider>
                          <ShipsProvider>
                            <LocationProvider>
                              <MapProvider>
                                <Routes>
                                  <Route path="/*" element={<App />} />
                                </Routes>
                              </MapProvider>
                            </LocationProvider>
                          </ShipsProvider>
                        </ConversationsProvider>
                      </SpeechProvider>
                    </SocketProvider>
                  </FrasarioProvider>
                </BoatInfoProvider>
              </SettingsProvider>
            </AuthProvider>
          </InfoProvider>
        </WidthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
